import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { installKioskSeed } from './lib/kioskSeed';

const container = document.getElementById('root');
if (!container) {
  // noUncheckedIndexedAccess/strict null checks make this explicit rather than a silent `!`. On a kiosk a
  // blank screen with no explanation is the worst possible failure, so fail loudly in the console instead.
  throw new Error('Root container #root is missing from index.html');
}

// Dev only, and compiled away entirely in a production build — see kioskSeed.ts.
installKioskSeed();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
